import { createFileRoute } from '@tanstack/react-router';
import ClientsView from '../admin/client/view';
export const Route = createFileRoute('/admin/clients/')({ component: ClientsView });
